/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ period: NonNullable<unknown> }} Progress_Report_Distribution_NoneInputs */

const en_us2_progress_report_distribution_none = /** @type {(inputs: Progress_Report_Distribution_NoneInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`No earlier weeks with training to compare with yet.`);
	return /** @type {LocalizedString} */ (`No earlier months with training to compare with yet.`)
	
};

const pt_br2_progress_report_distribution_none = /** @type {(inputs: Progress_Report_Distribution_NoneInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Ainda não há semanas anteriores com treino para comparar.`);
	return /** @type {LocalizedString} */ (`Ainda não há meses anteriores com treino para comparar.`)
	
};

const es_419_progress_report_distribution_none = /** @type {(inputs: Progress_Report_Distribution_NoneInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Aún no hay semanas anteriores con entrenamiento para comparar.`);
	return /** @type {LocalizedString} */ (`Aún no hay meses anteriores con entrenamiento para comparar.`)
	
};

const pt_pt2_progress_report_distribution_none = /** @type {(inputs: Progress_Report_Distribution_NoneInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Ainda não há semanas anteriores com treino para comparar.`);
	return /** @type {LocalizedString} */ (`Ainda não há meses anteriores com treino para comparar.`)
	
};

const fr_fr2_progress_report_distribution_none = /** @type {(inputs: Progress_Report_Distribution_NoneInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Pas encore de semaine d'entraînement antérieure à comparer.`);
	return /** @type {LocalizedString} */ (`Pas encore de mois d'entraînement antérieur à comparer.`)
	
};

const de_de2_progress_report_distribution_none = /** @type {(inputs: Progress_Report_Distribution_NoneInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Noch keine früheren Wochen mit Training zum Vergleich.`);
	return /** @type {LocalizedString} */ (`Noch keine früheren Monate mit Training zum Vergleich.`)
	
};

const it_it2_progress_report_distribution_none = /** @type {(inputs: Progress_Report_Distribution_NoneInputs) => LocalizedString} */ (i) => {
	if (i?.period === "week") return /** @type {LocalizedString} */ (`Non ci sono ancora settimane precedenti con allenamenti da confrontare.`);
	return /** @type {LocalizedString} */ (`Non ci sono ancora mesi precedenti con allenamenti da confrontare.`)
	
};

/**
* | period | output |
* | --- | --- |
* | "week" | "No earlier weeks with training to compare with yet." |
* | * | "No earlier months with training to compare with yet." |
*
* @param {Progress_Report_Distribution_NoneInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_report_distribution_none = /** @type {((inputs: Progress_Report_Distribution_NoneInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Report_Distribution_NoneInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_report_distribution_none(inputs)
	if (locale === "es-419") return es_419_progress_report_distribution_none(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_report_distribution_none(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_report_distribution_none(inputs)
	if (locale === "de-DE") return de_de2_progress_report_distribution_none(inputs)
	if (locale === "it-IT") return it_it2_progress_report_distribution_none(inputs)
	return en_us2_progress_report_distribution_none(inputs)
});
export { progress_report_distribution_none as "progress-report.distribution_none" }